import React from 'react';

const CircularSegmentsCount = ({
  total = 10,
  filled = 5,
  size = 40,
  radius = 16,
  strokeWidth = 5,
  offset = 2,
  filledColor = '#6ED828',
  emptyColor = '#2d2d2d',
}) => {
  const center = size / 2;
  const segmentAngle = (360 - total * offset) / total;

  const polarToCartesian = (cx, cy, r, angle) => {
    const rad = (Math.PI / 180) * (angle - 90);
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  };

  const describeArc = (startAngle, endAngle) => {
    const start = polarToCartesian(center, center, radius, endAngle);
    const end = polarToCartesian(center, center, radius, startAngle);
    const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  };

  const segments = Array.from({ length: total }).map((_, i) => {
    const start = i * (segmentAngle + offset);
    const end = start + segmentAngle;
    const isFilled = i < filled;
    return (
      <path
        key={i}
        d={describeArc(start, end)}
        stroke={isFilled ? filledColor : emptyColor}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="butt"
      />
    );
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {segments}
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={size * 0.35}
        fill="white"
        fontWeight="bold"
      >
        {filled}
      </text>
    </svg>
  );
};

export default CircularSegmentsCount;
